<template>
  <b-col cols="auto">
    <div v-if="description" class="mr-3">
      <span class="filter mr-3"> Filtro: </span>
      <span class="date-description"> Data </span>
    </div>
    <div v-if="showDay">
      <button class="btn-filters left" @click="setDay('last')">
        <strong> &lt; </strong>
      </button>
      <span class="date">{{ dateFilter.day }}</span>
      <button class="btn-filters right" @click="setDay('next')">
        <strong> &gt; </strong>
      </button>
    </div>

    <div v-if="showMonth">
      <button class="btn-filters left ml-3" @click="setMonth('last')">
        <strong> &lt; </strong>
      </button>
      <span class="date"> {{ dateFilter.month }} </span>
      <button class="btn-filters right mr-3" @click="setMonth('next')">
        <strong> &gt; </strong>
      </button>
    </div>

    <button class="btn-filters left" @click="setYear('last')">
      <strong> &lt; </strong>
    </button>
    <span class="date">{{ dateFilter.year }}</span>
    <button class="btn-filters right" @click="setYear('next')">
      <strong> &gt; </strong>
    </button>
  </b-col>
</template>

<script>
export default {
  data() {
    return {
      dateFilter: {
        day: '',
        month: '',
        year: null,
      },
      quantityDaysOfCurrentMonth: 0,
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      currentMonth: null,
    };
  },
  props: {
    showDay: {
      type: Boolean,
      default: false,
    },
    showMonth: {
      type: Boolean,
      default: false,
    },
    description: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    'dateFilter.month': {
      handler() {
        this.updateQuantityDays();
      },
    },
    'dateFilter.year': {
      handler() {
        this.updateQuantityDays();
      },
    },
  },
  methods: {
    updateQuantityDays() {
      const currentMonth = this.months.indexOf(this.dateFilter.month) + 1;
      const currentYear = this.dateFilter.year;
      const lastDayOfMonth = new Date(currentYear, currentMonth, 0).getDate();

      this.quantityDaysOfCurrentMonth = lastDayOfMonth;
      if (this.dateFilter.day > lastDayOfMonth) {
        this.dateFilter.day = lastDayOfMonth;
      }
      this.changeDateFilter();
    },
    changeDateFilter() {
      this.$emit('changeDate', { date: this.dateFilter });
    },
    setDay(typeSet) {
      const incrementDay = () => {
        if (this.dateFilter.day === '') {
          this.dateFilter.day = 1;
        } else if (
          this.dateFilter.day === this.quantityDaysOfCurrentMonth ||
          this.dateFilter.day > this.quantityDaysOfCurrentMonth
        ) {
          this.dateFilter.day = 1;
        } else {
          this.dateFilter.day += 1;
        }
      };

      const decrementDay = () => {
        if (this.dateFilter.day === '') {
          this.dateFilter.day = this.quantityDaysOfCurrentMonth;
        } else if (this.dateFilter.day === 1) {
          this.dateFilter.day = this.quantityDaysOfCurrentMonth;
        } else {
          this.dateFilter.day -= 1;
        }
      };

      const updateDay = typeSet === 'next' ? incrementDay : decrementDay;
      updateDay();
      this.changeDateFilter();
    },
    setMonth(typeSet) {
      const incrementMonth = () => {
        if (this.currentMonth === 11) {
          this.currentMonth = 0;
          this.dateFilter.month = this.months[this.currentMonth];
        } else {
          this.currentMonth += 1;
          this.dateFilter.month = this.months[this.currentMonth];
        }
      };

      const decrementMonth = () => {
        if (this.currentMonth === 0) {
          this.currentMonth = 11;
          this.dateFilter.month = this.months[this.currentMonth];
        } else {
          this.currentMonth -= 1;
          this.dateFilter.month = this.months[this.currentMonth];
        }
      };

      const updateMonth = typeSet === 'next' ? incrementMonth : decrementMonth;
      updateMonth();
      this.changeDateFilter();
    },
    setYear(typeSet) {
      const incrementYear = () => {
        this.dateFilter.year += 1;
      };

      const decrementYear = () => {
        this.dateFilter.year -= 1;
      };

      const updateYear = typeSet === 'next' ? incrementYear : decrementYear;
      updateYear();
      this.changeDateFilter();
    },
  },
  created() {
    const today = new Date();
    this.quantityDaysOfCurrentMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    ).getDate();
    this.currentMonth = today.getMonth();
    this.currentYear = today.getFullYear();
    this.dateFilter.day = today.getDate();
    this.dateFilter.month = this.months[this.currentMonth];
    this.dateFilter.year = this.currentYear;
    this.changeDateFilter();
  },
};
</script>

<style scoped>
div {
  display: inline;
}

.date,
.btn-filters {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-size: 18px;
  background: #d9d9d9;
  font-weight: 400;
  line-height: 20px;
  color: #2c2c2c;
}

.filter,
.date-description {
  line-height: 24px;
  color: rgba(0, 0, 0, 0.9);
}

.filter {
  font-size: 20px;
  font-weight: 500;
}

.date-description {
  font-size: 16px;
  font-weight: 300;
}

.date {
  border-radius: 0%;
  border: none;
}

.btn-filters {
  width: 30px;
  border: none;
}

.btn-filters:focus {
  border: none;
  outline: none;
}

.btn-filters.left {
  border-bottom-right-radius: 0%;
  border-top-right-radius: 0%;
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
}

.btn-filters.right {
  border-bottom-left-radius: 0%;
  border-top-left-radius: 0%;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}
</style>
